import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignRegistrarToCompany } from 'API/TRSRegistrar/assignRegistrarToCompany';

const useAssignRegistrar = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const assignRegistrar = async ({ registrarId, companyId }) => {
        try {
            const response = await assignRegistrarToCompany(
                registrarId,
                companyId,
            );
            return response.data;
        } catch (error) {
            console.error('Error assigning registrar to company:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: assignRegistrar,
        onSuccess: (data, variables) => {
            // Invalidate and refetch the registrars list for both companies
            queryClient.invalidateQueries({
                queryKey: ['Registrars'],
            });
            queryClient.invalidateQueries({
                queryKey: ['Registrars', variables.companyId],
            });
            // Invalidate the specific registrar
            queryClient.invalidateQueries({
                queryKey: ['Registrar', variables.registrarId],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useAssignRegistrar;
